import React from 'react';
import { Button, Typography, Alert, CircularProgress } from '@mui/material';
import s from './BookingDetailsPage.module.scss';

const ExtrasPickupStep = ({ product, formData, updateExtra, updateField, pickupList, pickupLoading, pickupError }) => {

    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 2
        }).format(price);
    };
    return (
        <>
            <Typography variant="h6" className={s.section__title}>追加オプション</Typography>
            {product.extras?.length > 0 ? (
                <div className={s.section}>

                    {product.extras.map(extra => {
                        const qty = formData.extras[extra.name] || 0;

                        return (
                            <div key={extra.name} className={s.extraCard}>

                                {/* IMAGE */}
                                <div className={s.extraCard__imageWrapper}>
                                    {extra.image?.thumbnailUrl ? (
                                        <img
                                            src={extra.image.thumbnailUrl}
                                            alt={extra.name}
                                            className={s.extraCard__image}
                                        />
                                    ) : (
                                        <div className={s.extraCard__placeholder}>
                                            画像なし
                                        </div>
                                    )}
                                </div>

                                {/* CONTENT */}
                                <div className={s.extraCard__content}>
                                    <h4>{extra.name}</h4>
                                    {extra.description && <p>{extra.description}</p>}

                                    <div className={s.extraCard__bottom}>
                    <span className={s.price}>
                        {extra.price === 0 ? "無料" : formatPrice(extra.price)}
                    </span>

                                        {/* COUNTER */}
                                        <div className={s.counter}>
                                            <button
                                                onClick={() => updateExtra(extra.name, qty - 1)}
                                                disabled={qty === 0}
                                            >-</button>

                                            <span>{qty}</span>

                                            <button
                                                onClick={() => updateExtra(extra.name, qty + 1)}
                                            >+</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className={s.section}>
                    <Typography variant="h6" className={s.section__title}>追加オプション</Typography>
                    <Alert severity="info" className="mt-4">
                        このツアーには追加オプションがありません。
                    </Alert>
                </div>
            )}


        </>
    );
};

export default ExtrasPickupStep;